export function amountValue(value) {
  const text = String(value ?? '').trim();
  if (!/^(?:0|[1-9][0-9]{0,8})(?:\.[0-9]{1,2})?$/.test(text) || Number(text) <= 0) return null;
  return Number(text).toFixed(2);
}

export function availableBalance(balances, currency) {
  const matches = balances.filter(row => row.currency === currency);
  return matches.length === 1 && typeof matches[0].amount === 'number' && Number.isFinite(matches[0].amount) ? matches[0].amount : null;
}

export function newOperationKey() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  let timestamp = Date.now();
  for (let i = 5; i >= 0; i--) { bytes[i] = timestamp % 256; timestamp = Math.floor(timestamp / 256); }
  bytes[6] = (bytes[6] & 15) | 112; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function savedIntent(agencyId) {
  const raw = window.sessionStorage.getItem(`cms-top-placement:${agencyId}`);
  if (!raw) return null;
  const intent = JSON.parse(raw);
  if (!/^[A-Z]{3}$/.test(intent.currency) || amountValue(intent.amount) !== intent.amount
    || !/^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(intent.operation_key)) throw new Error('Invalid saved withdrawal; contact finance before retrying.');
  return intent;
}

export function storeIntent(agencyId, intent) {
  const key = `cms-top-placement:${agencyId}`;
  if (intent) window.sessionStorage.setItem(key, JSON.stringify(intent));
  else window.sessionStorage.removeItem(key);
}
